<header class="action-header">
  <div class="container">
    <div class="row">
      <div class="col-12"></div>
    </div>
  </div>
</header>
<div class="container page-watch-list-bid">
  <div class="row position-xs-sticky">
    <div class="col-md-6 col-xs-12 d-flex justify-content-center justify-content-md-start">
      <div class="d-flex align-items-end justify-content-center flex-column flex-md-row">
        <h1 class="font-lg mb-0">Watch & Bid List</h1>
        <div *ngIf="auctionLotService.auctionId && auctionService.initialized" class="ml-2">
          <select name="auction" [(ngModel)]="auctionLotService.auctionId" (change)="OnAuctionChange(true)" style="max-width: 265px;" class="bg-neutral-25 text-red border-0 font-sm outline-0">
            <option *ngFor="let auction of auctionService.auctions" [value]="auction.Id">{{auction.Title}} ({{auction.Id}})</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xs-12 d-flex align-items-center justify-content-center justify-content-md-end">
      <div @fade class="d-flex justify-content-center flex-wrap bid-preview" *ngIf="myAuctionLotService.myAuctionLots$ | withLoading | async as myAuctionLots">
        <ng-template [ngIf]="myAuctionLots.value">
          <strong class="mr-1">Current:</strong>
          <div class="mr-1 right-outline">
            <span class="mr-1">Winning Bids</span> <span class="text-red mr-1">{{myAuctionLotService.currentWinningBids | inDollars}}</span>
          </div>
          <div class="mr-1 right-outline">
            <span class="mr-1">Maximum</span> <span class="text-red mr-1">{{myAuctionLotService.currentMaximum | inDollars}}</span>
          </div>
          <div class="mr-1">
            <span class="mr-1">BPA</span> <span class="text-red">{{myAuctionLotService.currentBpa | inDollars}}</span>
          </div>
        </ng-template>
        <ng-template [ngIf]="myAuctionLots.loading"><i @fade class="fa fa-spinner fa-spin"></i></ng-template>
      </div>
      <ng-template #loading><i @fade class="fa fa-spinner fa-spin"></i></ng-template>
    </div>
  </div>
  <div class="row align-items-center justify-content-between mt-4 bid-filters bg-neutral-25">
    <div class="d-flex col-md-8 flex-order-2 flex-order-md-1 mb-2 flex-wrap">
      <span class="mr-2">Showing: </span>
      <label class="form-check form-check-inline checkbox">
        <input class="form-check-input" type="checkbox" (change)="checkUncheckAll()" [(ngModel)]="showAll">
        <span></span>All
      </label>
      <label class="form-check form-check-inline checkbox">
        <input class="form-check-input manage-bids" type="checkbox" (change)="isAllSelected()" [(ngModel)]="showWatching">
        <span></span>Watching
      </label>
      <label class="form-check form-check-inline checkbox">
        <input class="form-check-input manage-bids" type="checkbox" (change)="isAllSelected()" [(ngModel)]="showWinning">
        <span></span>Winning
      </label>
      <label class="form-check form-check-inline checkbox">
        <input class="form-check-input manage-bids" type="checkbox" (change)="isAllSelected()" [(ngModel)]="showOutbid">
        <span></span>Outbid
      </label>
      <label class="d-inline-flex align-items-center checkbox ml-md-5">
        <input class="form-check-input" type="checkbox" [(ngModel)]="showHiddenBids">
        <span></span>Show Hidden
      </label>
    </div>
    <div class="col-md-4 d-flex justify-content-end flex-order-1 flex-order-md-2">
      <button class="btn btn-primary btn-red mb-3 w-100" (click)="ReviewAndConfirmBids()" [disabled]="!selectedBidCards.length">Confirm new bids</button>
    </div>
  </div>

  <div class="d-flex flex-column w-100 table-content">
    <div class="row auction-headers bg-neutral-50 d-none d-lg-flex p-3 mb-2">
      <div class="cell flex-1">Lot</div>
      <div class="cell cell-auction-info">Item</div>
      <div class="cell d-flex">
        <div class="flex-1">Estimate</div>
        <div class="flex-1">Winning Bid</div>
      </div>
      <div class="cell d-flex">
        <div class="flex-1">My Autobid</div>
        <div class="flex-1">Min Next Bid</div>
      </div>
      <div class="cell">New Max Bid (per bottle)</div>
    </div>

    <div #list class="bid-cards-container" *ngIf="initialized && myAuctionLotService.myAuctionLots$ | withLoading | async as obs">
      <ng-template [ngIf]="myAuctionLotService.myAuctionLots">
        <bid-list-card #bidCard *ngFor="let bid of myAuctionLotService.myAuctionLots" [lot]="bid.AuctionLot" (confirmBid)="ReviewAndConfirmBids()" (click)="onSelect($event,bid)" [ngClass]="{ 'mt-4': closedBidCards.indexOf(bidCard) === 0 && myAuctionLotService.myAuctionLots.indexOf(bid) > 0, 'bg-dark-x border-x': !bidCard.LotIsBiddable }" [ngStyle]="{display: Visible(bid) === true ? '' : 'none'}"></bid-list-card>
        <!-- <hr *ngIf="closedBidCards.indexOf(bidCard) === 0"> -->
      </ng-template>
      <div *ngIf="!obs.loading && (!myAuctionLotService.myAuctionLots || myAuctionLotService.myAuctionLots?.length === 0)" class="font-sm alert alert-warning rounded-0">
        <i class="fas fa-exclamation-circle text-red font-md p-0 pr-2"></i>
        <span class="text-opacity-7">Nothing in your list</span>
      </div>
      <ng-template [ngIf]="obs.loading"><i class="fa fa-spinner fa-spin"></i> Loading...</ng-template>
    </div>
    <ng-template #loading><i class="fa fa-spinner fa-spin"></i> Loading...</ng-template>
  </div>
</div>
